export const dict = {
    NoData: "No Data",
    elapsedTime: "You've been logged in for",
    shortHourKey: "h",
    shortMinuteKey: "mins",
    sportsbookNetWon: "Sport net won",
    sportsbookTurnover: "Sport turnover",
    casinoNetWon: "Casino net won",
    casinoTurnover: "Casino turnover",
    pleaseSelect: "Please select",
    btnSet: "Set",
    btnLink: "Betting History",
    btnLogOut: "Log Out"
};
//# sourceMappingURL=dict.js.map